import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { TemplateEditorBody } from "@/pages/Templates";

export default function TemplateEditor() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [existing, setExisting] = useState(undefined);

  useEffect(() => {
    if (!id) { setExisting(null); return; }
    api.get("/templates").then((r) => {
      const t = (r.data || []).find((x) => x.id === id);
      if (!t) { toast.error("Template non trovato"); navigate("/template", { replace: true }); return; }
      setExisting(t);
    }).catch(() => { toast.error("Impossibile caricare il template"); navigate("/template", { replace: true }); });
  }, [id, navigate]);

  if (existing === undefined) return <div className="flex items-center justify-center py-20 text-slate-500" data-testid="template-editor-loading"><Loader2 className="h-6 w-6 animate-spin" /></div>;
  return <TemplateEditorBody key={id || "new"} existing={existing} onDone={() => navigate("/template")} onBack={() => navigate("/template")} />;
}
